import type { ConnectorConfigDto } from '@atnt/shared';

/** "monitoring.uzgidro.uz" from a URL (the input itself when it is not a URL). */
export function hostOf(url: string) {
  try {
    return new URL(url).host || url;
  } catch {
    return url;
  }
}

/** Ingest URL a webhook source POSTs to (the API builds the same one; shown before saving thanks to the client id). */
export const webhookUrl = (id: string) => `${window.location.origin}/api/v1/ingest/webhooks/${id}`;

/** Where the data comes from, for list subtitles ("monitoring.uzgidro.uz", "10.0.4.12:502", "CSV"). */
export function sourceHost(config: ConnectorConfigDto): string {
  switch (config.type) {
    case 'atnt_unified':
    case 'rest':
      return hostOf(config.baseUrl);
    case 'mqtt':
      return hostOf(config.brokerUrl);
    case 'opcua':
      return hostOf(config.endpointUrl);
    case 'modbus_tcp':
      return `${config.host}:${config.port}`;
    case 'webhook':
      return hostOf(config.endpointUrl);
    case 'file_import':
      return config.format.toUpperCase();
  }
}
